// Module
var code = `<ex-multi-occurrence-maitre-details-ecran multi-occurrence-options="vm.multiOccurrenceOptions" lbl-titre="LBL_BLC_QAD"></ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;